var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.config.enable_celery_tasks)?_c('div',[_c(_setup.InvocationExportWizard,{attrs:{"invocation-id":_vm.invocationId}})],1):_c('div',[_c(_setup.BCard,{staticClass:"export-plugin-card",attrs:{"title":"BioCompute Object Export"}},[_c(_setup.BioComputeObjectExportCard,{attrs:{"invocation-id":_vm.invocationId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }